import { render, staticRenderFns } from "./company-patent.vue?vue&type=template&id=408daf72&scoped=true&"
import script from "./company-patent.vue?vue&type=script&lang=js&"
export * from "./company-patent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408daf72",
  null
  
)

export default component.exports